import { Base_Url } from "../../BaseURL/BaseUrl";
import { postApi } from "../ApiMethods/ApiMethod";

const loginUrl = `${Base_Url}/Login/AdminLogin`;

export const VerifyLoginCredential = async (params) => {
  //
  const res = await postApi(loginUrl, params);
  // const res = await Utils.LoginResponse;

  return res;
};
